/**
 * RFQ Intercept Script
 * 
 * Global script to be loaded on every page via theme.liquid.
 * 
 * What it does:
 *   1. Changes "Buy it Now" (dynamic checkout) button to "Request for Quote"
 *      and redirects to the RFQ page
 *   2. Changes the cart page "Checkout" button to "Request for Quote"
 *      and redirects to the RFQ page
 *   3. Cart "Add to Cart" stays as normal so users can still build their cart
 *
 * Installation:
 *   Add as rfq-intercept.js in Shopify Assets folder.
 *   In layout/theme.liquid, add before </body>:
 *   <script src="{{ 'rfq-intercept.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  var RFQ_PAGE_PATH = '/pages/request-for-quote';
  var RFQ_BUTTON_TEXT = 'Request for Quote';

  /* ── STYLES ─────────────────────────────────────────────── */

  var style = document.createElement('style');
  style.textContent = [
    /* Hide Shopify dynamic checkout (Buy it Now) button */
    '.shopify-payment-button { display: none !important; }',

    /* RFQ replacement button for Buy it Now */
    '.rfq-buy-now-btn {',
    '  background-color: #5B2D8E !important;',
    '  color: #ffffff !important;',
    '  border: none !important;',
    '  padding: 12px 24px !important;',
    '  font-size: 16px !important;',
    '  font-weight: 600 !important;',
    '  cursor: pointer !important;',
    '  text-align: center !important;',
    '  display: block !important;',
    '  width: 100% !important;',
    '  border-radius: 4px !important;',
    '  letter-spacing: 0.5px !important;',
    '  margin-top: 8px !important;',
    '  transition: background-color 0.2s ease !important;',
    '}',
    '.rfq-buy-now-btn:hover {',
    '  background-color: #471C8F !important;',
    '}',

    /* RFQ replacement for Checkout button on cart page */
    '.rfq-checkout-btn {',
    '  background-color: #5B2D8E !important;',
    '  color: #ffffff !important;',
    '  border: none !important;',
    '  padding: 14px 28px !important;',
    '  font-size: 16px !important;',
    '  font-weight: 600 !important;',
    '  cursor: pointer !important;',
    '  text-align: center !important;',
    '  display: block !important;',
    '  width: 100% !important;',
    '  border-radius: 4px !important;',
    '  letter-spacing: 0.5px !important;',
    '  transition: background-color 0.2s ease !important;',
    '}',
    '.rfq-checkout-btn:hover {',
    '  background-color: #471C8F !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  /* ── PRODUCT PAGE: Replace Buy it Now ──────────────────── */

  function replaceBuyItNow() {
    var dynamicBtns = document.querySelectorAll('.shopify-payment-button');

    dynamicBtns.forEach(function (container) {
      if (container.dataset.rfqReplaced === 'true') return;
      container.dataset.rfqReplaced = 'true';

      var rfqBtn = document.createElement('button');
      rfqBtn.type = 'button';
      rfqBtn.className = 'rfq-buy-now-btn';
      rfqBtn.textContent = RFQ_BUTTON_TEXT;

      rfqBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        /* Get product info from the page to add to cart first, then redirect */
        var form = container.closest('form') ||
                   document.querySelector('form[action*="/cart/add"]');

        if (form) {
          var formData = new FormData(form);
          fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(function () {
            window.location.href = RFQ_PAGE_PATH;
          })
          .catch(function () {
            /* If add to cart fails, still redirect */
            window.location.href = RFQ_PAGE_PATH;
          });
        } else {
          window.location.href = RFQ_PAGE_PATH;
        }
      });

      container.parentNode.insertBefore(rfqBtn, container.nextSibling);
    });
  }

  /* ── CART PAGE + CART DRAWER: Replace Checkout buttons ──── */

  function replaceCheckoutButton() {
    /*
     * No path restriction: this runs on every page because the
     * cart drawer can appear anywhere, not just /cart.
     */

    var checkoutBtns = document.querySelectorAll([
      /* Cart drawer (your theme's exact selector) */
      '.cart-drawer__checkout-buttons button[name="checkout"]',
      /* Full cart page selectors */
      'button[name="checkout"]',
      'input[name="checkout"]',
      'a[href="/checkout"]',
      'button.cart__checkout-button',
      '.cart__ctas button[type="submit"]',
      '.cart__ctas a[href="/checkout"]',
      '#checkout',
      '[data-checkout-button]'
    ].join(', '));

    checkoutBtns.forEach(function (btn) {
      if (btn.dataset.rfqReplaced === 'true') return;
      btn.dataset.rfqReplaced = 'true';

      var rfqBtn = document.createElement('button');
      rfqBtn.type = 'button';
      rfqBtn.className = 'btn btn--primary btn--icon-with-text w-full rfq-checkout-btn';
      rfqBtn.textContent = RFQ_BUTTON_TEXT;

      rfqBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = RFQ_PAGE_PATH;
      });

      btn.parentNode.insertBefore(rfqBtn, btn);
      btn.style.display = 'none';
    });

    /* Also hide any additional dynamic checkout buttons on cart */
    var additionalCheckouts = document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons');
    additionalCheckouts.forEach(function (el) {
      el.style.display = 'none';
    });
  }

  /* ── INIT ───────────────────────────────────────────────── */

  function init() {
    replaceBuyItNow();
    replaceCheckoutButton();

    /* MutationObserver for dynamically loaded content */
    var observer = new MutationObserver(function () {
      replaceBuyItNow();
      replaceCheckoutButton();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();